<div class="devices-page">
  <!-- Toolbar -->
  <div class="toolbar">
    <div class="search-box">
      <i class="bx bx-search"></i>
      <input
        type="text"
        placeholder="Search Devices..."
        [value]="searchTerm"
        (input)="onSearch($event)"
      />
    </div>

    <div class="right-controls">
      <div class="fnf-segmented fnf-segmented--compact" role="tablist">
        <button
          type="button"
          class="fnf-segment"
          [class.fnf-segment--active]="viewMode === 'list'"
          (click)="setViewMode('list')"
        >
          <i class="bx bx-list-ul" aria-hidden="true"></i> List
        </button>
        <button
          type="button"
          class="fnf-segment"
          [class.fnf-segment--active]="viewMode === 'grid'"
          (click)="setViewMode('grid')"
        >
          <i class="bx bx-grid-alt" aria-hidden="true"></i> Grid
        </button>
      </div>

      <div class="group-select">
        <span class="group-label">Group by:</span>
        <select [value]="groupBy" (change)="onGroupByChange($event)" aria-label="Group devices by">
          @for (option of groupOptions; track option.value) {
            <option [value]="option.value">{{ option.label }}</option>
          }
        </select>
      </div>
    </div>
  </div>

  @if (displayLoading) {
    <div
      class="d-flex flex-column align-items-center justify-content-center common-loading-container"
    >
      <div class="w-25 text-center">
        <img class="common-loading" src="assets/menu_loading.gif" alt="common loading" />
        <p class="common-loading-text">Loading devices, please wait...</p>
      </div>
    </div>
  } @else if (filteredDevices.length > 0) {
    @if (viewMode === 'list') {
      <!-- Table view -->
      <div class="list-card">
        <div class="list-head list-row">
          <span class="col-name">Device Name</span>
          <span class="col-status">Status</span>
          @if (groupBy !== 'device_type') {
            <span class="col-type">Device Type</span>
          }
          @if (groupBy !== 'station') {
            <span class="col-station">Station</span>
          }
          <span class="col-added">Added</span>
        </div>

        @for (group of deviceGroups; track group.label; let groupIndex = $index) {
          @if (group.label) {
            <div class="group-header" [class.spaced]="groupIndex > 0">
              <span class="group-name">{{ group.label | titlecase }}</span>
              <span class="group-count">
                {{ group.devices.length }}
                {{ group.devices.length === 1 ? 'device' : 'devices' }}
              </span>
            </div>
          }

          @for (device of group.devices; track device) {
            <div class="list-row">
              <div class="col-name name-cell">
                <span class="device-icon"><i [class]="deviceIcon(device.device_type)"></i></span>
                <span class="device-name">{{ device.device_name | titlecase }}</span>
              </div>
              <span class="col-status">
                <span class="status-pill" [class]="statusTone(device.device_status)">
                  <span class="dot"></span>
                  {{ device.device_status | titlecase }}
                </span>
              </span>
              @if (groupBy !== 'device_type') {
                <span class="col-type">{{ device.device_type | titlecase }}</span>
              }
              @if (groupBy !== 'station') {
                <span class="col-station">
                  {{ device.station ? (device.station.station_name | titlecase) : '-' }}
                </span>
              }
              <span class="col-added">{{ device.added_at | date: 'MMM d, y' }}</span>
            </div>
          }
        }

        <div class="list-footer">
          <span>
            Showing {{ filteredDevices.length }}
            {{ filteredDevices.length === 1 ? 'device' : 'devices' }}
            @if (groupBy === 'none') {
              across {{ stationCount }} {{ stationCount === 1 ? 'station' : 'stations' }}
            } @else {
              across {{ groupCount }} {{ groupCount === 1 ? 'category' : 'categories' }}
            }
          </span>
        </div>
      </div>
    } @else {
      <!-- Card grid -->
      @for (group of deviceGroups; track group.label) {
        @if (group.label) {
          <div class="grid-group-header">
            <span class="group-name">{{ group.label | titlecase }}</span>
            <span class="group-count">
              {{ group.devices.length }}
              {{ group.devices.length === 1 ? 'device' : 'devices' }}
            </span>
          </div>
        }

        <div class="device-grid">
          @for (device of group.devices; track device) {
            <div class="device-card">
              <div class="device-card-header">
                <span class="device-name">{{ device.device_name | titlecase }}</span>
                <div class="card-actions">
                  <button type="button" class="card-action-btn edit" aria-label="Edit device">
                    <i class="bx bx-edit-alt"></i>
                  </button>
                  <button type="button" class="card-action-btn delete" aria-label="Delete device">
                    <i class="bx bx-trash"></i>
                  </button>
                </div>
              </div>

              <span class="status-row" [class]="'status-row ' + statusTone(device.device_status)">
                <span class="dot"></span>
                {{ device.device_status | titlecase }}
              </span>

              <div class="card-meta">
                <span class="meta-station">
                  Station: {{ device.station ? (device.station.station_name | titlecase) : '-' }}
                </span>
                <span class="meta-added">Added: {{ device.added_at | date: 'MMM d, y' }}</span>
              </div>
            </div>
          }
        </div>
      }
    }
  } @else if (devices.length > 0) {
    <div
      class="d-flex flex-column align-items-center justify-content-center common-empty-container"
    >
      <img src="assets/not-found.png" alt="No matches" class="common-empty-img mb-3" />
      <p class="common-empty-header">No Matching Devices</p>
      <p class="common-empty-sub-text">Try a different search term.</p>
    </div>
  } @else {
    <div
      class="d-flex flex-column align-items-center justify-content-center common-empty-container"
    >
      <img src="assets/not-found.png" alt="No Devices" class="common-empty-img mb-3" />
      <p class="common-empty-header">No Devices Connected</p>
      <p class="common-empty-sub-text">
        All the connected devices through the POS will be listed here.
      </p>
    </div>
  }
</div>
